<template>
  <CustomContainer customClass="embroidery-confirm-view" elementType="section">
    <CustomText
      customClass="embroidery-confirm-view-title text-center"
      elementType="h5"
      keyTranslation="embroideryConfirmViewStep"
    />
    <EmbroideryImagesView
      ref="imagesComponent"
      :itemsToPersonalize="itemsToPersonalize"
      @images-loaded="imagesLoaded"
    />
    <CustomContainer customClass="embroidery-confirm-view-swatches">
      <CustomContainer customClass="embroidery-confirm-view-swatches-list" elementType="ul">
        <CustomContainer
          customClass="embroidery-confirm-view-swatches-list-colors"
          elementType="li"
          :id="`color-${ index }`"
          :style="{ backgroundColor: item.name, color: iconCheckColor }"
          v-bind:key="index"
          v-for="(item, index) in colors"
          @click="changeFontColor(item)"
        >
          <CustomText customClass="icon-check" />
        </CustomContainer>
      </CustomContainer>
    </CustomContainer>
  </CustomContainer>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomText from '@/components/Globals/CustomText.vue';
import EmbroideryImagesView from '@/components/molecule.embroidery.imagesView.vue';

import confirmView from '@/mixins/Embroidery/ConfirmView';

@Component({
  components: {
    CustomContainer,
    CustomText,
    EmbroideryImagesView,
  },
  mixins: [confirmView],
})
export default class EmbroideryConfirmVue extends Vue {}
</script>
